import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar';
import FormControl from '@mui/material/FormControl';
import { Container, TextField, Select, Box, Typography } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { t } from 'i18next';
import { Controller, useForm } from 'react-hook-form';
import currencies from '../../data/currencies';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';
import axios from 'axios';
import { useDropzone } from "react-dropzone";
import { CloudUpload as CloudUploadIcon } from '@mui/icons-material';
import { useCurriculums } from '../../hooks/useCurriculums';
import { useClasses } from '../../hooks/useClasses';
function EditPackage() {
    const { id } = useParams()
    const [levels, setLevels] = useState([]);
    const [error, setError] = useState(null);
    const lang = Cookies.get("i18next") || "en";
    const { enqueueSnackbar } = useSnackbar();
    const [file, setFile] = useState();
    const [close, setClose] = useState(false);
    const [Package, setPackage] = useState()
    const [loading, setLoading] = useState(false);
    const { teacher } = useSelector((state) => state.teacher);
    const i18next = Cookies.get('i18next');
    let [LevelData, setLevelData] = useState([]);
    const navigate = useNavigate();
    const { data: Curriculums } = useCurriculums()
    const { data: Classes } = useClasses()
    const Classrooms = [
        { id: "First semester", label: t("First semester") },
        { id: "Second semester", label: t("First semester") }
    ]
    const [fileImageName, setFileImageName] = useState('');
    const [Image, setImage] = useState();
    const [fileName, setFileName] = useState('');
    const { register, handleSubmit, formState: { errors }, control, getValues, reset } = useForm({
        defaultValues: {
            level: '',
            classId: '',
            semester: '',
            curriculums: '',
            titleAr: '',
            titleEn: '',
            duration: '',
            price: '',
            currency: '',
            startDate: '',
            endDate: '',
            packageType: '',
            numberOfShares: '',
            sharesInWeek: '',
            descriptionAr: '',
            descriptionEn: '',
            teacherId: '',
            linkPackage:""
        }
    });

    useEffect(() => {
        const fetchLevels = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_KEY}api/v1/admin/levels`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setLevels(data.data);
                for (const key in levels) {
                    if (levels[key].id === Package.level) {
                        setLevelData(levels[key]);
                    }
                }
            } catch (err) {
                console.error("Error fetching levels:", err);
                setError(err.message);
            }
        };

        const fetchPackageData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_KEY}api/v1/packages/get-package/${id}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setPackage(data); // Assuming the package contains a level property
                setLoading(true)
            } catch (err) {
                setError(err.message);
            }
        };

        // Fetch data
        fetchLevels();
        fetchPackageData();
    }, [id]);

    function convertDate(dateString) {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0]; // yyyy-mm-dd
    }
    useEffect(() => {
        if (Package?.startDate && Package?.endDate) {
            reset({
                level: Package?.level?.id,
                classId: Package?.classId?.id,
                semester: Package.semester,
                curriculums: Package?.curriculums?.id,
                titleAr: Package.titleAr,
                titleEn: Package.titleEn,
                duration: Package.duration,
                price: Package.price,
                currency: Package.currency,
                startDate: convertDate(Package.startDate),
                endDate: convertDate(Package.endDate),
                packageType: Package.packageType,
                numberOfShares: Package.numberOfShares,
                sharesInWeek: Package.sharesInWeek,
                descriptionAr: Package.descriptionAr,
                descriptionEn: Package.descriptionEn,
                teacherId: Package.teacherId,
                linkPackage: Package.linkPackage
            });
            setFileImageName(Package.image)
            setFileName(Package.docs)
        }
    }, [Package, reset]); // هنا، سيتم تنفيذ هذا الـ useEffect عند تغيير الـ Package فقط

    const { getRootProps: getRootPropsImage, getInputProps: getInputPropsImage } = useDropzone({
        onDrop: (acceptedFiles) => handleFileUpload(acceptedFiles),  // عند اختيار الصورة
        accept: 'image/*'  // تحديد أن نوع الملف المسموح به هو الصور
    });
      const { getRootProps: getRootPropsFile, getInputProps: getInputPropsFile } = useDropzone({
        onDrop: (acceptedFiles) => handleFile(acceptedFiles),  // عند اختيار المستند
        accept: '.pdf,.doc,.docx,.ppt,.pptx,.txt'  // تحديد أن نوع الملف المسموح به هو المستندات
      });
    // هذه دالة التعامل مع صورة
    const handleFileUpload = (files) => {
        if (files && files[0]) {
            setFileImageName(files[0].name);  // تخزين اسم الصورة
            setImage(files[0]);

        }
    };

      // هذه دالة التعامل مع المستند
  const handleFile = (files) => {
    if (files && files[0]) {
      setFileName(files[0].name);  // تخزين اسم المستند
      setFile(files[0]);

    }
  };
    async function createPackage(data) {

        const startDateTime = new Date(data.startDate); // تحويل إلى كائن تاريخ
        const endDateTime = new Date(data.endDate); // تحويل إلى كائن تاريخ

        // // تحقق من أن startDate أقل من endDate
        if (startDateTime >= endDateTime) {
            enqueueSnackbar(t("Start date must be earlier than end date"), { variant: "error", autoHideDuration: 5000 });
            return; // إنهاء الوظيفة إذا كان الشرط غير محقق
        }

        data.startDate = startDateTime;
        data.endDate = endDateTime;

        const formData = new FormData();
        if(Image)
        formData.append("image", Image);
        if(file)
        formData.append("docs", file);
        formData.append("teacherId", teacher.id);
        for (const key in data) {
            if (key !== "image" && key !== "teacherId" && key !== "docs") { // تجنب إضافة الصورة مرتين
                formData.append(key, data[key]);
            }
        }
        try {
            await axios.put(`${process.env.REACT_APP_API_KEY}api/v1/packages/edit-package/${id}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            enqueueSnackbar(t("packageEditMsg"), { variant: "success", autoHideDuration: 5000 });
            navigate("/teacher/package")

        } catch (err) {
            enqueueSnackbar("Data submission failed", { variant: "error", autoHideDuration: 5000 });
            setLoading(false);
            console.error("Error:", err);
            throw new Error("Something went wrong: " + err);
        }
    }


    return (
        <Navbar>
            <Container sx={{ marginTop: '120px', marginBottom: '80px' }}>
                <h1 className="text-3xl text-center my-4">{t("Edit Package")}</h1>
                <form sx={{ margin: 'auto' }} encType="multipart/form-data" onSubmit={handleSubmit(createPackage)}>
                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("titleAr")}
                        </InputLabel>
                        <Controller
                            name="titleAr"
                            control={control}
                            render={({ field }) => <TextField  {...field} fullWidth />}
                            rules={{ required: t("required") }}
                        />
                    </Box>
                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("titleEn")}
                        </InputLabel>
                        <Controller
                            name="titleEn"
                            control={control}
                            render={({ field }) => <TextField  {...field} fullWidth />}
                            rules={{ required: t("required") }}
                        />
                    </Box>
                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("level")}
                        </InputLabel>
                        <Controller
                            name="level"
                            control={control}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    fullWidth
                                    {...register("level", {
                                        required: t("isRequired"),
                                    })}
                                >
                                    {i18next === "ar"
                                        ? levels.map((level, index) => (
                                            <MenuItem key={index} value={level.id}>{t(level.titleAR)}</MenuItem>
                                        ))
                                        : levels.map((level, index) => (
                                            <MenuItem key={index} value={level.id}>{t(level.titleEN)}</MenuItem>
                                        ))
                                    }
                                </Select>
                            )}
                            rules={{ required: t("required") }}
                        />
                    </Box>

                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("classes")}
                        </InputLabel>
                        <Controller
                            name="classId"
                            control={control}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    fullWidth
                                    {...register("classId", {
                                        required: t("isRequired"),
                                    })}
                                >
                                    {
                                        Classes?.data.map((calss, index) => (
                                            <MenuItem key={index} value={calss.id}>{i18next === "ar" ? calss.titleAR : calss.titleEN}</MenuItem>
                                        ))
                                    }
                                </Select>
                            )}
                            rules={{ required: t("required") }}
                        />
                    </Box>
                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("studyCurriculum")}
                        </InputLabel>
                        <Controller
                            name="curriculums"
                            control={control}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    fullWidth
                                    {...register("curriculums", {
                                        required: t("isRequired"),
                                    })}
                                >
                                    {
                                        Curriculums?.data.map((Curriculum, index) => (
                                            <MenuItem key={index} value={Curriculum.id}>{i18next === "ar" ? Curriculum.titleAR : Curriculum.titleEN}</MenuItem>
                                        ))
                                    }
                                </Select>
                            )}
                            rules={{ required: t("required") }}
                        />
                    </Box>
                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("semester")}
                        </InputLabel>
                        <Controller
                            name="semester"
                            control={control}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    fullWidth
                                    {...register("semester", {
                                        required: t("isRequired"),
                                    })}
                                >
                                    {Classrooms?.length > 0 ? (
                                        Classrooms.map((curriculums, index) => (
                                            <MenuItem key={index} value={curriculums.id}>
                                                {t(curriculums.id)}
                                            </MenuItem>
                                        ))
                                    ) : (
                                        <MenuItem disabled>{t("noData")}</MenuItem>
                                    )}
                                </Select>
                            )}
                            rules={{ required: t("required") }}
                        />
                    </Box>


                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("price")}
                        </InputLabel>
                        <Controller
                            name="price"
                            control={control}
                            render={({ field }) => <TextField  {...field} fullWidth />}
                            rules={{ required: t("required") }}
                        />
                    </Box>
                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("currency")}
                        </InputLabel>
                        <Controller
                            name="currency"
                            control={control}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    fullWidth
                                    {...register("currency", {
                                        required: t("isRequired"),
                                    })}
                                >
                                    {
                                        currencies.map((curr) => {
                                            return <MenuItem value={curr.title}>{lang === "en" ? curr.titleEn : curr.titleAr}</MenuItem>
                                        })
                                    }
                                </Select>
                            )}
                            rules={{ required: t("required") }}
                        />
                    </Box>
                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("packageType")}
                        </InputLabel>
                        <Controller
                            name="packageType"
                            control={control}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    fullWidth
                                    {...register("packageType", {
                                        required: t("isRequired"),
                                    })}
                                >
                                    <MenuItem value={"online"}>
                                        {lang === "ar" ? "عن بعد" : "online"}
                                    </MenuItem>
                                    <MenuItem value={"student"}>
                                        {lang === "ar" ? "في منزل الطالب" : "Student home"}
                                    </MenuItem>
                                    <MenuItem value={"teacher"}>
                                        {lang === "ar" ? "في منزل المعلم" : "Teacher home"}
                                    </MenuItem>
                                </Select>
                            )}
                            rules={{ required: t("required") }}
                        />
                    </Box>
                    <Box sx={{ marginBottom: "18px" }}>
                        <Box sx={{ width: "100%" }}>
                            <InputLabel sx={{ marginBottom: "6px", fontSize: "13px" }}>
                                {t("lessonDate")}
                            </InputLabel>
                            <Controller
                                name="startDate"
                                control={control}
                                render={({ field }) => (
                                    <TextField type="date" {...field} fullWidth />
                                )}
                                {...register("startDate", {
                                    required: "start Date Address is required",
                                })}
                            />
                            {errors.date?.type === "required" && (
                                <Typography
                                    color="error"
                                    role="alert"
                                    sx={{ fontSize: "13px", marginTop: "6px" }}
                                >
                                    {t("required")}
                                </Typography>
                            )}
                        </Box>
                        {/* ------------------------------- */}
                    </Box>
                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "13px", marginTop: "3px" }}>
                            {t("lessonEndDate")}
                        </InputLabel>
                        <Controller
                            name="endDate"
                            control={control}
                            render={({ field }) => (
                                <TextField type="date" {...field} fullWidth />
                            )}
                            {...register("endDate", {
                                required: "End Date Address is required",
                            })}
                        />
                        {errors.date?.type === "required" && (
                            <Typography
                                color="error"
                                role="alert"
                                sx={{ fontSize: "13px", marginTop: "6px" }}
                            >
                                {t("required")}
                            </Typography>
                        )}
                    </Box>
                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("sharesCount")}
                        </InputLabel>
                        <Controller
                            name="numberOfShares"
                            control={control}
                            render={({ field }) => <TextField  {...field} fullWidth />}
                            rules={{ required: t("required") }}
                        />
                    </Box>
                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("sharesCountInWeek")}
                        </InputLabel>
                        <Controller
                            name="sharesInWeek"
                            control={control}
                            render={({ field }) => <TextField  {...field} fullWidth />}
                            rules={{ required: t("required") }}
                        />
                    </Box>
                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("duration")}
                        </InputLabel>
                        <Controller
                            name="duration"
                            control={control}
                            render={({ field }) => <TextField  {...field} fullWidth />}
                            rules={{ required: t("required") }}
                        />
                    </Box>
                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("descriptionArea")}
                        </InputLabel>
                        <Controller
                            name="descriptionAr"
                            control={control}
                            render={({ field }) => <TextField multiline rows={5} {...field} fullWidth />}
                            rules={{ required: t("required") }}
                        />
                    </Box>
                    <Box sx={{ marginBottom: "18px" }}>
                        <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
                            {t("descriptionAreaEnglish")}
                        </InputLabel>
                        <Controller
                            name="descriptionEn"
                            control={control}
                            render={({ field }) => <TextField multiline rows={5} {...field} fullWidth />}
                            rules={{ required: t("required") }}
                        />
                    </Box>
                    <Box sx={{ marginBottom: "18px" }}>
            <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
              {t("Package link (if you do not include documents related to the Package, you must include a link to the Package)")}
            </InputLabel>

            <FormControl fullWidth margin='dense'>
              <TextField type="text"  {...register("linkPackage", {
                required: {
                  // value: !file,
                  message: t("file_video-validation")
                },
                pattern: {
                  value: /^(https?:\/\/)?(www\.youtube\.com|youtu\.be)\/.+$/,
                  message: t("youtube_link")
                }
              })} />

              <p className='text-red-500'>{errors.linkPackage?.message}</p>
            </FormControl>
          </Box>
          <Box sx={{  maxWidth: "100%" }}>
            <Box sx={{ marginBottom: "18px" }}>
              <InputLabel sx={{ marginBottom: "6px", fontSize: "14px", fontWeight: 'bold', color: '#333' }}>
                {t("Package documents")}
              </InputLabel>
              <div {...getRootPropsFile()} style={{
                border: '2px dashed #1976d2',
                padding: '20px',
                textAlign: 'center',
                cursor: 'pointer',
                borderRadius: '4px'
              }}>
                <input {...getInputPropsFile()} />
                <CloudUploadIcon sx={{ fontSize: "30px", color: "#1976d2" }} />
                <Typography sx={{ fontSize: "14px", color: "#1976d2", marginTop: "8px" }}>
                  {t("Package documents")}
                </Typography>
              </div>

              {/* عرض اسم المستند بعد اختياره */}
              {fileName && (
                <Typography sx={{ marginTop: "10px", fontSize: "17px", color: "red", textAlign: "center" }}>
                  {t("Selected File")}: {fileName}
                </Typography>
              )}
            </Box>

            <Box sx={{ marginBottom: "18px" }}>
              <InputLabel sx={{ marginBottom: "6px", fontSize: "14px", fontWeight: 'bold', color: '#333' }}>
                {t("Choose a suitable image for the package")}
              </InputLabel>
              <div {...getRootPropsImage()} style={{
                border: '2px dashed #1976d2',
                padding: '20px',
                textAlign: 'center',
                cursor: 'pointer',
                borderRadius: '4px'
              }}>
                <input {...getInputPropsImage()} />
                <CloudUploadIcon sx={{ fontSize: "30px", color: "#1976d2" }} />
                <Typography sx={{ fontSize: "14px", color: "#1976d2", marginTop: "8px" }}>
                  {t("Choose a suitable image for the package")}
                </Typography>
              </div>

              {/* عرض اسم الصورة بعد اختياره */}
              {fileImageName && (
                <Typography sx={{ marginTop: "10px", fontSize: "17px", color: "red", textAlign: "center" }}>
                  {t("selected Image")}: {fileImageName}
                </Typography>
              )}
            </Box>
          </Box>

                    <br />
                    <LoadingButton
                        type="submit"
                        variant="contained"
                    >{t("Edit Package")}
                    </LoadingButton>
                </form>
            </Container>
        </Navbar>
    )
}

export default EditPackage;
